import { createTheme } from '@mui/material/styles';

export const spTheme = {
  spacing: 8,
  typography: {
    fontSize: 12,
    lineHeight: 1.2,
  },
  palette: {
    primary: {
      main: '#3f51b5',
    },
    secondary: {
      main: '#f50057',
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          letterSpacing: 0,
        },
        containedSizeSmall: {
          padding: '4px 8px',
          minWidth: 64,
          fontSize: '0.8125rem',
        },
        outlined: {
          border: '1px solid rgba(0, 0, 0, 0.23)',
          '&:hover': {
            border: '1px solid rgba(0, 0, 0, 0.45)',
          },
        },
      },
    },
    MuiToggleButton: {
      styleOverrides: {
        root: {
          padding: '4px 12px',
        },
      },
    },
    MuiListItemText: {
      styleOverrides: {
        inset: {
          paddingLeft: '16px !important',
        },
      },
    },
    MuiListItemIcon: {
      styleOverrides: {
        root: {
          minWidth: 56,
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        body1: {
          color: 'rgba(0, 0, 0, 0.87)',
        },
        caption: {
          color: 'rgba(0, 0, 0, 0.54)',
          lineHeight: '1.375em',
        },
      },
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          height: '48px',
          '&.MuiTableRow-hover:hover': {
            backgroundColor: 'rgba(0, 0, 0, 0.08)',
          },
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          padding: '4px 16px',
          fontSize: '0.8125rem',
          fontWeight: 400,
        },
        head: {
          color: 'rgba(0, 0, 0, 0.54)',
          fontSize: '0.75rem',
          fontWeight: 500,
          lineHeight: 1.2,
        },
      },
    },
    MUIDataTableBodyRow: {
      styleOverrides: {
        root: {
          '&.mui-row-selected': {
            backgroundColor: 'rgba(0, 0, 0, 0.04)',
            '&:hover': {
              backgroundColor: 'rgba(0, 0, 0, 0.08)',
            },
          },
        },
      },
    },
    MUIDataTableHeadCell: {
      styleOverrides: {
        data: {
          color: 'rgba(0, 0, 0, 0.54)',
          fontSize: '0.75rem',
          fontWeight: 500,
        },
      },
    },
    MuiTablePagination: {
      styleOverrides: {
        root: {
          color: 'rgba(0, 0, 0, 0.54)',
          borderBottom: 0,
        },
      },
    },
    MuiTabs: {
      styleOverrides: {
        flexContainer: {
          '@media (min-width: 600px)': {
            marginLeft: 36,
          },
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          lineHeight: '1.1em',
          fontSize: '0.8125rem',
          fontWeight: 500,
        },
      },
    },
    MuiTabScrollButton: {
      styleOverrides: {
        root: {
          width: '56px',
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        label: {
          paddingLeft: 8,
          paddingRight: 8,
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        root: {
          marginTop: 8,
          marginBottom: 4,
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        input: {
          padding: '8px',
        },
      },
    },
  },
};

export default createTheme(spTheme);
